var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleNotch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 256C496 388.344 388.344 496 256 496S16 388.344 16 256C16 149.438 87.469 54.547 189.797 25.25C194.094 23.938 198.484 26.484 199.687 30.734C200.906 34.984 198.453 39.406 194.203 40.625C98.703 67.984 32 156.547 32 256C32 379.516 132.484 480 256 480S480 379.516 480 256C480 156.547 413.297 67.984 317.797 40.625C313.547 39.406 311.094 34.984 312.312 30.734C313.516 26.484 317.875 23.906 322.203 25.25C424.531 54.547 496 149.438 496 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNotch);
export default __webpack_public_path__ + "static/media/circle-notch.272c09ee1f9cc94b0f1cc2db82f09916.svg";
export { ForwardRef as ReactComponent };